import React from 'react';
import { ArrowRight, Award, Users, Building } from 'lucide-react';

const info = {
  name: "Javier Blanco Rojo",
  company: "JBR INMOBILIARIA",
  tagline: "Tu propiedad en las mejores manos",
  description: "Desde 2004 transformando la experiencia inmobiliaria en Castilla y León. Fundador de JBR INMOBILIARIA, con más de 5.000 transacciones realizadas y reconocido como la Mejor Inmobiliaria de CyL en Google durante 4 años consecutivos.",
  photo: "https://customer-assets.emergentagent.com/job_09d353ef-58ed-4cff-8b7c-745e46b33f91/artifacts/abt2en0d_IMG_9921.PNG"
};

const stats = [
  { number: "5.000+", label: "Transacciones" },
  { number: "21", label: "Años de Experiencia" },
  { number: "4x", label: "Premio Mejor Inmobiliaria" }
];

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector('#contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToAbout = (e) => {
    e.preventDefault();
    document.querySelector('#sobre-mi')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="min-h-screen bg-[#fffef2] pt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="order-2 lg:order-1">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#f6f5e8] rounded-full">
                <span className="w-2 h-2 bg-[#1a365d] rounded-full"></span>
                <span className="text-sm text-[#666666]">Fundador de {info.company}</span>
              </div>
              
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-[#333333] leading-tight">
                {info.name}
              </h1>
              
              <p className="text-xl lg:text-2xl text-[#1a365d] font-light">
                {info.tagline}
              </p>
              
              <p className="text-base lg:text-lg text-[#666666] leading-relaxed max-w-xl">
                {info.description}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <button
                  onClick={scrollToContact}
                  className="flex items-center justify-center gap-2 px-8 py-4 bg-[#1a365d] text-white text-sm font-medium hover:bg-[#2d4a7c] transition-all duration-200 group"
                >
                  Solicitar Consulta Gratuita
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
                <button
                  onClick={scrollToAbout}
                  className="flex items-center justify-center gap-2 px-8 py-4 border border-[#bcbbb4] text-[#333333] text-sm font-medium hover:border-[#333333] transition-all duration-200"
                >
                  Conocer más
                </button>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-12 pt-12 border-t border-[#ebeade]">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Building className="w-5 h-5 text-[#1a365d]" />
                </div>
                <p className="text-2xl lg:text-3xl font-light text-[#333333]">{stats[0].number}</p>
                <p className="text-xs text-[#666666] mt-1">{stats[0].label}</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Users className="w-5 h-5 text-[#1a365d]" />
                </div>
                <p className="text-2xl lg:text-3xl font-light text-[#333333]">{stats[1].number}</p>
                <p className="text-xs text-[#666666] mt-1">{stats[1].label}</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Award className="w-5 h-5 text-[#1a365d]" />
                </div>
                <p className="text-2xl lg:text-3xl font-light text-[#333333]">{stats[2].number}</p>
                <p className="text-xs text-[#666666] mt-1">{stats[2].label}</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#f6f5e8] -z-10"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#1a365d]/10 -z-10"></div>
              <img
                src={info.photo}
                alt={info.name}
                className="w-full max-w-md lg:max-w-lg object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
